<template>
  <div class="main">
    <div class="contain" v-if="sitename != ''">
      <a-card hoverable title="首页缓存" class="siteinfo" :bordered="false">
        <div class="intro">打开开关，网站<code>{{sitename}}</code>PC端首页将变为每8小时更新一次。或在预览后手动发布。</div>
        <div class="operate">
          <div class="text">
            <a-icon type="desktop" />首页缓存
          </div>
          <div class="switch">
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="indexCache"
              @change="setIndexCache"
            />
          </div>
        </div>
        <div class="operate">
          <div class="text">
            <a-icon type="cluster" />栏目/专题缓存
          </div>
          <div class="switch">
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :default-checked="false"
              disabled
            />
          </div>
        </div>
        <div class="operate">
          <div class="text">
            <a-icon type="file-protect" />内容缓存
          </div>
          <div class="switch">
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :default-checked="false"
              disabled
            />
          </div>
        </div>
      </a-card>
    </div>
    <div class="spin" v-else>
          <a-spin tip="Loading..." />
    </div>
  </div>
</template>

<script>
import { Icon } from 'ant-design-vue';
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1391373_suybzs2x9f.js'
});

export default {
  name: 'EditUser',
  data() {
    return {
      indexCache: false,
      listCache: false,
      contentCache: false,
      sitename: ''
    };
  },
  created() {
    this.siteinfo();
  },
  methods: {
    async setIndexCache() {
      let res = await this.$http.post('/api/Snapshot/setCache');
      if (res.data.state == 200) {
        this.$success({
          title: '成功',
          content: '操作成功！'
        });
        this.siteinfo()
      } else {
        this.$error({
          title: '错误',
          content: '操作失败，请刷新页面重试'
        });
      }
    },
    async siteinfo() {
      let res = await this.$http.post('/api/Snapshot/getCacheStatus');
      if (res.data.state == 200) {
        this.indexCache = res.data.data.cache == 0 ? false : true;
        this.sitename = res.data.data.sitename;
      } else {
        this.$error({
          title: '错误',
          content: '获取配置错误，请联系管理员。'
        });
      }
    }
  }
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.contain {
  margin-top: 2px;
  position: absolute;
  /*padding: 10px 0 0 10px;*/
  top: 0;
  left: 0;
  right: 0;
  bottom: 5px;
  overflow: hidden;
}
.contain .siteinfo {
  margin: 20px auto;
  width: 800px;
}
.contain .siteinfo >>> .ant-card-head-title {
  padding-left: 20px;
}
.contain .siteinfo >>> .ant-card-body {
  padding: 20px;
  min-height: 200px;
}
.intro {
  padding-left: 20px;
  margin-bottom: 20px;
  color: hsl(0, 0%, 60%);
  text-align: left;
}
.operate {
  height: 50px;
  position: relative;
}
.operate .text {
  font-size: 18px;
  position: absolute;
  left: 20px;
}
.operate .text i {
  margin-right: 10px;
}
.operate .switch {
  position: absolute;
  right: 50px;
}
.spin {
  width: 100%;
  height: 400px;
  line-height: 400px;
  text-align: center;
}
code {
    margin: 0 1px;
    background: #f2f4f5;
    padding: .2em .4em;
    border-radius: 3px;
    font-size: .9em;
    color: #7e7e7e;
    border: 1px solid #eee;
}
</style>